import React, { ReactNode, useEffect, useState } from 'react';
import './CommentContent.css';
import {TagMatch} from '../../types/types';
import reactStringReplace from 'react-string-replace';
import Tooltip from './Tooltip';
import { getTagExplanation } from '../../utils/tagUtils';

interface CommentContentProps {
  content: string;
  tagMatch: TagMatch | TagMatch[];
  isHighlightEnabled: boolean;
  className?: string;
  highlightedFrame?: string
}

const CommentContent: React.FC<CommentContentProps> = ({ content, tagMatch, isHighlightEnabled, className, highlightedFrame }) => {
  const [highlightedContent, setHighlightedContent] = useState<string|ReactNode[]>([]);


  useEffect(() => {
    if (!isHighlightEnabled && !highlightedFrame) {
      setHighlightedContent(content);
      return;
    }
    let highlightedContent: (string|ReactNode[]) = content;
    const tagMatchTemp = Array.isArray(tagMatch) ? tagMatch : [tagMatch];
    const tagMatches = highlightedFrame ? tagMatchTemp.filter(({ tag }) => tag === highlightedFrame) : tagMatchTemp;
    if (!tagMatch) return;

    tagMatches.forEach(({ tag, text, explanation }, idx) => {
      if (!text) return; // Skip empty text
      const escapedText = text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special regex characters
      const regex = new RegExp(`(${escapedText})`, 'gi');
      const cssClass = tag.toLowerCase().replace('/', '-');
      const { description, color } = getTagExplanation(tag);

      highlightedContent = reactStringReplace(highlightedContent, regex, (match, i) => (
        <Tooltip key={idx} content={explanation || description} color={color}>
          <span key={idx} className={`highlight ${cssClass}`}>{match}</span>
        </Tooltip>
      ));
      setHighlightedContent(highlightedContent);
    });
  }, [content, tagMatch, isHighlightEnabled, highlightedFrame]);

  

  return <p className={className || "comment-content"}>{highlightedContent}</p>;

  // const highlightedContent = tagMatches.reduce((acc, { tag, text }) => {
  //   if (!text) return acc; // Skip empty text
  //   const escapedText = text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special regex characters
  //   const regex = new RegExp(`(${escapedText})`, 'gi');
  //   const cssClass = tag.toLowerCase().replace('/', '-');
  //   return acc.replace(regex, `<span class="highlight ${cssClass}">$1</span>`);
  // }, content);

  // console.log('CommentContent.tsx: highlightedContent:', highlightedContent);

  // return <p className={className || "comment-content"} dangerouslySetInnerHTML={{ __html: highlightedContent }} />;
};

export default CommentContent;